<div class="customer-support-mobile-toggle-container hidden-desktop">
  <img
    (click)="toggleSupportMobile()"
    src="assets\images\customer-support-mobile.svg"
    alt="Customer Support Phone Icon"
  />
</div>
<div
  id="customer-support-container"
  class="customer-support-container"
  [ngClass]="displayMobile ? '' : 'hidden-mobile'"
>
  <div class="customer-support-item">
    <img
      class="customer-support-icon"
      src="assets\images\stellar-support-phone-icon.svg"
      alt="Customer Support Phone Icon"
    />
    <div class="customer-support-content">
      <p class="customer-support-label">
        {{ labels?.stellar?.customerSupport?.phoneLabel }}
      </p>
      <a
        [href]="
          labels.stellar.customerSupport.supportPhoneNumberHref ||
          'tel:800-513-5175'
        "
        class="customer-support-info"
        >{{ labels?.stellar?.customerSupport?.supportPhoneNumber }}</a
      >
    </div>
  </div>
  <div class="customer-support-item">
    <img
      class="customer-support-icon"
      src="assets\images\help-request-icon.svg"
      alt="Customer Support Phone Icon"
    />
    <div class="customer-support-content">
      <p class="customer-support-label">
        {{ labels?.stellar?.customerSupport?.submitHelpRequest }}​
      </p>
      <ng-container *ngIf="isMobile$ | async; else isNotMobile">
        <p class="customer-support-info">
          <a
            href="#"
            (click)="openDialog(labels?.stellar?.customerSupport?.supportUrl)"
            >{{ labels?.stellar?.customerSupport?.onlineHelpForm }}</a
          >
        </p>
      </ng-container>
      <ng-template #isNotMobile>
        <p class="customer-support-info">
          <a
            href="{{ labels?.stellar?.customerSupport?.supportUrl }}"
            target="_blank"
            >{{ labels?.stellar?.customerSupport?.onlineHelpForm }}</a
          >
        </p>
      </ng-template>
    </div>
  </div>
  <div class="customer-support-item">
    <img
      class="customer-support-icon"
      src="assets\images\support-email-icon.svg"
      alt="Customer Support Phone Icon"
    />
    <div class="customer-support-content">
      <p class="customer-support-label">
        {{ labels?.stellar?.customerSupport?.emailLabel }}
      </p>
      <p class="customer-support-info">
        <a href="mailto:{{ labels?.stellar?.customerSupport?.emailAddress }}">{{
          labels?.stellar?.customerSupport?.emailAddress
        }}</a>
      </p>
    </div>
  </div>
</div>
